export default "__VITE_ASSET__CibscSxi__"